import { chain } from 'lodash';
import { country_codes } from '@fiverr-private/phone_verification';

export const REASON_FIELD = 'reason';

export const SUB_REASON_FIELD = 'sub_reason';

export const COMMENT_FIELD = 'comment';

export const VIOLATION_LOCATION = 'violation_location';

export const IP_VIOLATION_DETAILS = 'ip_violation_details';

export const ORIGINAL_ELEMENT_LINK = 'original_element_link';

export const COPYRIGHT_OWNER = 'copyright_owner';

export enum IP_VIOLATION_DETAILS_FIELDS {
    VIOLATION_DESCRIPTION = 'violation_description',
    UNREGISTERED_TRADEMARK_RIGHTS_PROOF = 'unregistered_trademark_rights_proof',
    VIOLATING_CONTENT_LINK = 'violating_content_link',
    OWNERSHIP_PROOF_LINK = 'ownership_proof_link',
    ISSUING_OFFICE = 'issuing_office',
    REGISTRATION_NUMBER = 'registration_number',
    SIGNATURE = 'signature',
    IS_OWNERSHIP_STATEMENT_OF_ACCURACY_CONFIRMED = 'is_ownership_statement_of_accuracy_confirmed',
}

export enum COPYRIGHT_OWNER_FIELDS {
    NAME = 'name',
    ADDRESS = 'address',
    COUNTRY = 'country',
    PHONE = 'phone',
    COUNTRY_CODE = 'country_code',
}

export const ISSUE_TIME_HOURS = 'issue_time_hours';
export const ISSUE_TIME_MINUTES = 'issue_time_minutes';
export const ISSUE_TIME_SECONDS = 'issue_time_seconds';

export const LINK_PLACEHOLDER = 'www.example.com';

export enum ISSUES {
    PROHIBITED_SERVICE = 'PROHIBITED_SERVICE',
    INAPPROPRIATE_CONTENT_OR_BEHAVIOR = 'INAPPROPRIATE_CONTENT_OR_BEHAVIOR',
    NON_ORIGINAL_CONTENT = 'NON_ORIGINAL_CONTENT',
    ILLEGAL_CONTENT = 'ILLEGAL_CONTENT',
    INTELLECTUAL_PROPERTY_VIOLATION = 'IP_VIOLATION',
    INCLUDES_PAYMENT_OR_CONTACT_INFORMATION = 'INCLUDES_PAYMENT_OR_CONTACT_INFORMATION',
    WORK_DISPLAYED_WITHOUT_CONSENT = 'WORK_DISPLAYED_WITHOUT_CONSENT',
    IP_COPYRIGHT_STEP_1 = 'IP_COPYRIGHT_STEP_1',
    IP_COPYRIGHT_STEP_2 = 'IP_COPYRIGHT_STEP_2',
    IP_TRADEMARK_STEP_1 = 'IP_TRADEMARK_STEP_1',
    IP_TRADEMARK_STEP_2 = 'IP_TRADEMARK_STEP_2',
    SPAM = 'SPAM',
    BUSINESS_OFF_FIVERR = 'BUSINESS_OFF_FIVERR',
}

export enum PROHIBITED_SERVICE_SUB_REASONS {
    MAY_HARM_USERS = 'MAY_HARM_USERS',
    FINANCIAL_RISK = 'FINANCIAL_RISK',
    THIRD_PARTY_TOS_INFRINGEMENT = 'THIRD_PARTY_TOS_INFRINGEMENT',
    MISLEADING_OR_DECEPTIVE = 'MISLEADING_OR_DECEPTIVE',
    ACADEMIC_DISHONESTY = 'ACADEMIC_DISHONESTY',
    SHARING_PERSONAL_INFO = 'SHARING_PERSONAL_INFO',
    MEDICAL = 'MEDICAL',
}

export enum INAPPROPRIATE_CONTENT_OR_BEHAVIOR_SUB_REASONS {
    ADULT_CONTENT = 'ADULT_CONTENT',
    HATE_SPEECH = 'HATE_SPEECH',
    DISCRIMINATORY = 'DISCRIMINATORY',
    THREAT_OR_VIOLENCE = 'THREAT_OR_VIOLENCE',
    OFFENSIVE = 'OFFENSIVE',
    MISINFORMATION = 'MISINFORMATION',
    SELF_HARM = 'SELF_HARM',
    TERRORISM = 'TERRORISM',
    UNDERMINING_ELECTION_INTEGRITY = 'UNDERMINING_ELECTION_INTEGRITY',
    IMPERSONATING_OR_MISREPRESENTING_SKILLS = 'IMPERSONATING_OR_MISREPRESENTING_SKILLS',
    MALWARE_OR_PHISHING = 'MALWARE_OR_PHISHING',
    UNSOLICITED_OFFERS = 'UNSOLICITED_OFFERS',
    REQUEST_FOR_SELLING_GUIDANCE = 'REQUEST_FOR_SELLING_GUIDANCE',
    PROMOTION_OF_SERVICES = 'PROMOTION_OF_SERVICES',
    FREE_WORK_REQUEST = 'FREE_WORK_REQUEST',
    MAY_HARM_USERS = 'MAY_HARM_USERS',
    PROMOTING_BANNED_OR_DANGEROUS_ITEMS = 'PROMOTING_BANNED_OR_DANGEROUS_ITEMS',
    SEXUAL_EXPLOITATION = 'SEXUAL_EXPLOITATION',
    EXPLOITS_MINORS = 'EXPLOITS_MINORS',
    ONLINE_THREATS = 'ONLINE_THREATS',
    FINANCIAL_RISK = 'FINANCIAL_RISK',
    MISLEADING_OR_DECEPTIVE = 'MISLEADING_OR_DECEPTIVE',
    ACADEMIC_DISHONESTY = 'ACADEMIC_DISHONESTY',
    MEDICAL_SERVICES = 'MEDICAL_SERVICES',
    SHARING_PERSONAL_INFO = 'SHARING_PERSONAL_INFO',
    THIRD_PARTY_TOS_INFRINGEMENT = 'THIRD_PARTY_TOS_INFRINGEMENT',
}

export enum IP_VIOLATION_SUB_REASONS {
    COPYRIGHT = 'COPYRIGHT',
    TRADEMARK = 'TRADEMARK',
}

export enum VIOLATION_LOCATION_VALUES {
    TEXT = 'TEXT',
    VIDEO_AUDIO = 'VIDEO_AUDIO',
    IMAGE = 'IMAGE',
}

export const EVIDENCE_FIELD = 'evidence';

export const IS_STATEMENT_OF_GOOD_FAITH_CONFIRMED_FIELD = 'is_statement_of_good_faith_confirmed';

export const IS_STATEMENT_OF_ACCURACY_CONFIRMED_FIELD = 'is_statement_of_accuracy_confirmed';

export const IS_CHILD_SAFETY_ENABLED_FIELD = 'is_child_safety_enabled';

export const COPYRIGHT_DETAILS_URL = 'DETAILS';

export const REGISTERED_TRADEMARK_FIELD = 'registered_trademark';

export enum TRADEMARK_OPTIONS {
    REGISTERED = 'REGISTERED',
    UNREGISTERED = 'UNREGISTERED',
}

export const REGISTERED_COPYRIGHT_OFFICE_FIELD = 'registered_copyright_office';
export const REGISTERED_COPYRIGHT_NUMBER_FIELD = 'registered_copyright_number';
export const REPORT_ANONYMOUSLY_CHECKBOX_NAME = 'is_anonymous';
export const GOOD_FAITH_CHECKBOX_NAME = 'is_statement_of_good_faith_confirmed';
export const URL_VALIDATION_CONFIG = {
    pattern: '(https?://)?[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}(/.*)?',
    validate: (value: string) => {
        const urlPattern = new RegExp('(https?://)?[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}(/.*)?');
        return urlPattern.test(value) || 'Please enter a valid URL.';
    },
};

const COUNTRIES = {
    AF: 'Afghanistan',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua & Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    AX: 'Åland Islands',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia & Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    VG: 'British Virgin Islands',
    BN: 'Brunei',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    BQ: 'Caribbean Netherlands',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo - Brazzaville',
    CD: 'Congo - Kinshasa',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: 'Côte d’Ivoire',
    HR: 'Croatia',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard & McDonald Islands',
    HN: 'Honduras',
    HK: 'Hong Kong SAR China',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    XK: 'Kosovo',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Laos',
    LV: 'Latvia',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macau SAR China',
    MK: 'Macedonia',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar (Burma)',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestinian Territories',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn Islands',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RU: 'Russia',
    RW: 'Rwanda',
    WS: 'Samoa',
    SM: 'San Marino',
    SA: 'Saudi Arabia',
    ST: 'São Tomé & Príncipe',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten',
    SK: 'Slovakia',
    SI: 'Slovenia',
    GS: 'So. Georgia & So. Sandwich Isl.',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    KR: 'South Korea',
    ES: 'Spain',
    LK: 'Sri Lanka',
    BL: 'St. Barthélemy',
    SH: 'St. Helena',
    KN: 'St. Kitts & Nevis',
    LC: 'St. Lucia',
    MF: 'St. Martin',
    PM: 'St. Pierre & Miquelon',
    VC: 'St. Vincent & Grenadines',
    SR: 'Suriname',
    SJ: 'Svalbard & Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad & Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks & Caicos Islands',
    TV: 'Tuvalu',
    UM: 'U.S. Outlying Islands',
    VI: 'U.S. Virgin Islands',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VA: 'Vatican City',
    VE: 'Venezuela',
    VN: 'Vietnam',
    WF: 'Wallis & Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
};

export const PHONECODE_OPTIONS = chain(country_codes)
    .toPairs()
    .map(([key, value]) => ({
        label: `${key} (${value})`,
        key,
        value,
    }))
    .sortBy('label')
    .value();

export const COUNTRY_OPTIONS = chain(COUNTRIES)
    .toPairs()
    .map(([code, name]) => ({
        textKey: `countries.${code}` || name,
        value: name,
    }))
    .sortBy('label')
    .value();
